import { Quote } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../lib/SiteContext";
import { Reveal, Overline } from "./Reveal";

export const Testimonials = () => {
  const { t, lang } = useLang();
  const { testimonials } = useSite();
  const pick = (s, k) => (lang === "hi" && s[`${k}_hi`]) || s[k];
  if (!testimonials.length) return null;

  return (
    <section className="py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <Overline>{t.stories.over}</Overline>
          <h2 className="section-title mt-5">{t.stories.title}</h2>
        </Reveal>
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((s, i) => (
            <Reveal key={s.id || i} delay={i * 0.1} className="bento group flex h-full flex-col p-0" data-testid={`testimonial-card-${i}`}>
              {s.image && (
                <div className="h-52 overflow-hidden rounded-t-[24px]">
                  <img src={s.image} alt={s.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
              )}
              <div className="flex flex-1 flex-col p-7">
                <Quote className="text-saffron" size={22} />
                <p className="mt-4 flex-1 text-base leading-relaxed text-slate-200">“{pick(s, "quote")}”</p>
                <div className="mt-6 flex items-end justify-between gap-3 border-t border-white/10 pt-5">
                  <div>
                    <p className="font-display font-semibold text-white">{s.name}</p>
                    <p className="text-xs text-slate-400">{pick(s, "role")} · {pick(s, "location")}</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-emerald/15 px-3 py-1 font-mono text-xs text-emerald-300">{s.earning}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
